import React, {useCallback, useState} from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import Dialog from 'scenes/Dialog';
import Popup from 'components/Popup';
import UxHelpers from 'helpers/ux-helpers.js';
import FormRadio from '../../../../components/FormRadio';

const OPTIONS = [
  {
    label: 'Took a new job and am off the market',
    message: 'Congratulations on the new role. We’ve paused your emails for 9 months.',
    value: 'tookJob',
    pauseDuration: 9,
  },
  {
    label: 'Am in the same job but am off the market',
    message: 'Thanks for letting us know.  We’ve paused your emails for 6 months',
    value: 'sameJob',
    pauseDuration: 6,
  },
  {
    label: 'Not fully off the market, but am recruiting elsewhere or taking a break',
    message: 'Thanks for letting us know. We’ve paused your emails for 3 months',
    value: 'break',
    pauseDuration: 3,
  },
  {
    label: 'Am still recruiting on GoBuyside but was getting too many emails',
    message: 'You\'re been receiving too many emails. Do you want to:',
    value: 'tooManyEmails',
    pauseDuration: 0,
  }
];

const PauseEmailsDialog = props => {
  const { show, proceed, dismiss } = props;
  const [value, setValue] = useState(null);

  const proceedHandler = useCallback(() => {
    proceed(OPTIONS.find(o => o.value === value));
    UxHelpers.overflowLock('unlock');
  }, [proceed, value]);

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={() => dismiss()}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Cancel"
      />
      <BasicButton
        controlFunc={() => { proceedHandler() }}
        disabled={!value}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText="Pause emails"
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <h3 style={{ textAlign: 'center', fontWeight: '500' }}>
        Please let us know why you’re taking a break from emails.
      </h3>
      <div className={'pause-email-dialog__radio'}>
        <FormRadio
          options={OPTIONS}
          value={value}
          onChange={(v) => {
            setValue(v.target.value)
          }}
        />
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{ proceed, dismiss }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(PauseEmailsDialog));
